import {
  getLeoUuid,
  LeoUUID,
  getObject,
  getOptionalObject,
} from "@surya-digital/leo-ts-types";
import { BoundedName, BoundedNameDTO } from "../types/boundedName";
import { Project, ProjectDTO } from "./project";

export interface EmailTemplateDTO {
  id: string;
  templateName: BoundedNameDTO;
  project?: ProjectDTO | null;
}

export class EmailTemplate {
  readonly isEmailTemplateEmailTemplate: boolean = true;

  readonly id: LeoUUID;
  readonly templateName: BoundedName;
  readonly project: Project | null;


  constructor(
  id: LeoUUID, 
  templateName: BoundedName, 
  project: Project | null = null
  ) {
    this.id = id;
    this.templateName = templateName;
    this.project = project;
  }

  static fromDTO(dto: EmailTemplateDTO): EmailTemplate {
    const id = getLeoUuid(dto, "id", InvalidEmailTemplateIdError);
    const templateName = BoundedName.fromDTO(getObject(dto, "templateName", InvalidEmailTemplateTemplateNameError));
    let project = getOptionalObject(dto, "project");
    if(project !== undefined && project !== null) {
      project = Project.fromDTO(getObject(dto, "project", InvalidEmailTemplateProjectError));
    }
    return new EmailTemplate(
      id,
      templateName,
      project
    );
  }

  toDTO(): EmailTemplateDTO {
    const dto: EmailTemplateDTO = {
        id: this.id.toDTO(),
        templateName: this.templateName.toDTO(),
    };
    if (this.project !== undefined && this.project !== null){
      dto.project = this.project.toDTO();
    }
    return dto;
  }
  }

EmailTemplate.prototype.toString = function toString(): string {
  return `EmailTemplate(id='${this.id}',templateName='${this.templateName}',project='${this.project}')`;
};

export class InvalidEmailTemplateError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidEmailTemplateError";
  }
}
export class InvalidEmailTemplateIdError extends InvalidEmailTemplateError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidEmailTemplateIdError";
  }
}

export class InvalidEmailTemplateTemplateNameError extends InvalidEmailTemplateError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidEmailTemplateTemplateNameError";
  }
}

export class InvalidEmailTemplateProjectError extends InvalidEmailTemplateError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidEmailTemplateProjectError";
  }
}
